import React from 'react';
import { ReactComponent as LearningIcon } from '@whitelabel/media/icons/learning.svg';
import { ReactComponent as AffiliatesIcon } from '@whitelabel/media/icons/affiliates.svg';
import { ReactComponent as ClaimsIcon } from '@whitelabel/media/icons/claims.svg';
import { ReactComponent as TicketCoverIcon } from '@whitelabel/media/icons/policies/ticket.svg';
import { ReactComponent as TravelCoverIcon } from '@whitelabel/media/icons/policies/travel.svg';
import { ReactComponent as ProductCoverIcon } from '@whitelabel/media/icons/policies/product.svg';
import { ReactComponent as ParcelCoverIcon } from '@whitelabel/media/icons/policies/parcel.svg';
import { ReactComponent as TripCoverIcon } from '@whitelabel/media/icons/policies/trip.svg';
import { ReactComponent as EarthquakeCoverIcon } from '@whitelabel/media/icons/earthquake.svg';
import { ReactComponent as RentalIcon } from '@whitelabel/media/icons/Icon-rental.svg';
import IconCardButton from '../../IconCardButton';
import { StyledGridContainer, StyledBlockHeader, StyledBlockSubTitle } from './styledThreeColumnButtonGrid';
import { IGridBox, IThreeColumnButtonGridProps } from './IThreeColumnButtonGrid';

const iconMap = {
  information_icon: LearningIcon,
  claim_process_icon: ClaimsIcon,
  ticket_protection_icon: TicketCoverIcon,
  travel_protection_icon: TravelCoverIcon,
  product_protection_icon: ProductCoverIcon,
  parcel_protection_icon: ParcelCoverIcon,
  ride_protection_icon: TripCoverIcon,
  earthquake_protection_icon: EarthquakeCoverIcon,
  affiliates_icon: AffiliatesIcon,
  rental_icon: RentalIcon,
};
export type IconMapType = typeof iconMap;

const ThreeColumnButtonGrid = ({ title, gridBoxes, subTitle }: IThreeColumnButtonGridProps): JSX.Element => {
  return (
    <div>
      <StyledBlockHeader>{title}</StyledBlockHeader>
      <StyledBlockSubTitle>{subTitle}</StyledBlockSubTitle>
      <StyledGridContainer>
        {gridBoxes.map(
          ({ title, description, icon, link }: IGridBox) =>
            iconMap[icon] && (
              <IconCardButton key={link} description={description} title={title} link={link} svgIcon={iconMap[icon]} />
            ),
        )}
      </StyledGridContainer>
    </div>
  );
};

export default ThreeColumnButtonGrid;
